module.exports = __webpack_public_path__ + "img/pic_Ind_Jakarta.1ea31dce.jpg";